import { Menu, MenuItem } from '@mui/material';
import { useState, Fragment, type MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@eye-able/ui';
import { languages } from '@/i18n';

const LanguageSelect = () => {
  const { i18n, t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const currentLang = i18n.resolvedLanguage;
  const open = Boolean(anchorEl);

  const handleOpenMenu = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSelect = async (code: string) => {
    setAnchorEl(null);
    await i18n.changeLanguage(code);
  };

  return (
    <Fragment>
      <Button
        type='button'
        variant='ghost'
        onClick={handleOpenMenu}
        aria-expanded={open ? 'true' : undefined}
        id='lang-button'
        aria-haspopup='listbox'
        aria-controls='lang-menu'
      >
        <img
          alt=''
          aria-hidden
          src={getFlag(currentLang)}
          style={{ width: '30px' }}
        />
        <span className='eye:max-xl:sr-only'>{t('language')}</span>
      </Button>

      <Menu
        id='lang-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        MenuListProps={{
          'aria-labelledby': 'lang-button',
          role: 'listbox',
        }}
      >
        {Object.entries(languages).map(([code, option]) => (
          <MenuItem
            key={code}
            selected={code === currentLang}
            aria-current={code === currentLang ? 'true' : undefined}
            onClick={() => {
              void handleSelect(code);
            }}
            role='option'
          >
            <img
              className='eye:border eye:border-grey-20 eye:w-[36px] eye:h-[27px] eye:mr-12'
              src={getFlag(code)}
              alt=''
              aria-hidden
            />
            <b>{option.name}</b>
          </MenuItem>
        ))}
      </Menu>
    </Fragment>
  );
};

function getFlag(code?: string) {
  if (!code) return '';

  return `https://assets.eye-able.com/dashboard-assets/flags/${code}.svg`;
}

export default LanguageSelect;
